module.exports = __webpack_public_path__ + "static/img/iphone_ldttitle6.f0992d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldttitle6.png
// module id = LxAk
// module chunks = 0